import { render, staticRenderFns } from "./termReport.vue?vue&type=template&id=89aa611e&scoped=true&"
import script from "./termReport.vue?vue&type=script&lang=js&"
export * from "./termReport.vue?vue&type=script&lang=js&"
import style0 from "./termReport.vue?vue&type=style&index=0&id=89aa611e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89aa611e",
  null
  
)

export default component.exports